import React, { useEffect, useState } from "react";
import { Figure } from "../../shared/utils/Figure";
import Image from "next/image";
import filter_icon from "../assets/filter.svg";
import styled from "styled-components";
import { RxCross2 } from "react-icons/rx";
import useFilterStore from "../lib/hall_of_fame_store";

const Filter = () => {
  const [isHover, setIsHover] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);

  console.log("clearFilter", clearFilter);

  return (
    <div className="flex relative items-center gap-2 bg-[rgba(255,255,255,0.15)] rounded-[3rem] p-2">
      <div className="bg-[#005EEF] rounded-full w-8 h-8 flex justify-center items-center">
        {isHover ? (
          <RxCross2
            onClick={() => setIsHover(false)}
            className="text-white w-4 h-4 cursor-pointer"
            title="Close"
          />
        ) : (
          <Figure
            onClick={() => setIsHover(true)}
            className="w-4 h-4 object-contain cursor-pointer"
            title="Filter"
          >
            <Image src={filter_icon} alt="Filter Icon" />
          </Figure>
        )}
      </div>
      <span className="font-unilever-shilling-medium text-white mr-2 text-xs">
        FILTER
      </span>
      <HOFFilter
        isHover={isHover}
        clearFilter={clearFilter}
        setClearFilter={setClearFilter}
      />
      {isHover && (
        <span
          onClick={() => setClearFilter(true)}
          className="font-unilever-shilling-normal whitespace-nowrap cursor-pointer text-white mr-2 text-xs"
        >
          Clear Filter
        </span>
      )}
    </div>
  );
};

const HOFFilter = ({ isHover, clearFilter, setClearFilter }) => {
  const [dateLimit, setDateLimit] = useState({
    minDate: "",
    maxDate: "",
  });

  const [date, setDate] = useState({
    startDate: "",
    endDate: "",
  });

  const { setFilterDate } = useFilterStore();

  const { minDate, maxDate } = dateLimit;
  const { startDate, endDate } = date;

  const handleDateChane = (e) => {
    setDate({ ...date, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setDateLimit((prev) => ({ ...prev, maxDate: today }));
  }, []);

  useEffect(() => {
    if (startDate && endDate) {
      setFilterDate({ startDate, endDate });
      setClearFilter(false);
    }
    //eslint-disable-next-line
  }, [startDate, endDate]);

  useEffect(() => {
    if (clearFilter && startDate && endDate) {
      setDate({
        startDate: "",
        endDate: "",
      });
      setFilterDate({
        startDate: "",
        endDate: "",
      });
    }
    //eslint-disable-next-line
  }, [clearFilter]);

  return (
    <div
      className={`bg-[#005EEF] ${
        isHover ? "px-3 mr-2" : "px-0"
      } text-white rounded-[3rem] text-sm flex items-center font-unilever-shilling-normal`}
      style={{
        visibility: isHover ? "visible" : "hidden",
        width: isHover ? "390px" : "0px",
        transition: "all linear 300ms",
      }}
    >
      <div className="flex items-center gap-2 !border-r-2 pr-3 py-1 !border-[#2676f1]">
        <span className="">From</span>
        <InputDate
          type="date"
          name="startDate"
          max={endDate ? endDate : maxDate}
          value={startDate}
          onChange={handleDateChane}
        />
      </div>
      <div className="flex items-center gap-2 pl-3 py-1">
        <span>To</span>
        <InputDate
          type="date"
          name="endDate"
          min={startDate}
          max={maxDate}
          value={endDate}
          onChange={handleDateChane}
        />
      </div>
    </div>
  );
};

const InputDate = styled.input`
  background-color: #005eef;
  color: #fff;
  &::-webkit-calendar-picker-indicator {
    background-image: url("/hof_date.svg");
    cursor: pointer;
    scale: 1.5;
    position: relative;
    left: 6px;
  }
  outline: none;
  border: none;
  text-transform: uppercase;
`;

export default Filter;

